const PERMISSIONS = {
  DEFAULT: "default",

  /*************************** VENDOR PERMISSIONS ***************************/
  VENDOR_CAR_CREATE: "vendor.cars.create",
  VENDOR_DRIVER_CREATE: "vendor.drivers.create",
  VENDOR_TOLL_CREATE: "vendor.tolls.create",
  VENDOR_COMPANY_CREATE: "vendor.companies.create",
  VENDOR_CONTRACT_CREATE: "vendor.contracts.create",
  VENDOR_CAR_TYPE_CREATE: "vendor.car_types.create",
  VENDOR_TRIP_TYPE_CREATE: "vendor.trip_types.create",
  VENDOR_TAX_TYPE_CREATE: "vendor.tax_types.create",
  VENDOR_BILLING_ITEM_CREATE: "vendor.billing_items.create",
  VENDOR_LABEL_CREATE: "vendor.labels.create",
  VENDOR_INVOICE_CREATE: "vendor.invoices.create",
  VENDOR_PETTY_CASH_CREATE: "vendor.petty_cash.create",
  VENDOR_FUEL_TRANSACTION_CREATE: "vendor.fuel_transactions.create",
  VENDOR_EXPENDITURE_CREATE: "vendor.expenditures.create",
  VENDOR_TRIP_CREATE: "vendor.trips.create",
  VENDOR_TRIP_LABEL_CREATE: "vendor.trip_labels.create",
  VENDOR_PASSENGER_CREATE: "vendor.passengers.create",
  VENDOR_ROLE_CREATE: "vendor.roles.create",
  VENDOR_USER_CREATE: "vendor.users.create",
  VENDOR_TRIP_BILLING_ITEM_CREATE: "vendor.trip_billing_items.create",
  VENDOR_TRIP_CHARGES_CREATE: "vendor.trip_charges.create",
  VENDOR_TRIP_COMPLETED_CREATE: "vendor.trips_completed.create",
  VENDOR_SAVE_INVOICE_CREATE: "vendor.save_invoices.create",
  VENDOR_EMAIL_CREATE: "vendor.email.create",
  VENDOR_FILE_CREATE: "vendor.files.create",
  VENDOR_GARAGE_CREATE: "vendor.garage.create",


  VENDOR_CAR_READ: "vendor.cars.read",
  VENDOR_ALL_CAR_READ: "vendor.all_cars.read",
  VENDOR_LOCATION_READ: "vendor.locations.read",
  VENDOR_DRIVER_READ: "vendor.drivers.read",
  VENDOR_VENDOR_READ: "vendor.vendors.read",
  VENDOR_COMPANY_READ: "vendor.companies.read",
  VENDOR_CONTRACT_READ: "vendor.contracts.read",
  VENDOR_CAR_TYPE_READ: "vendor.car_types.read",
  VENDOR_TRIP_TYPE_READ: "vendor.trip_types.read",
  VENDOR_TAX_TYPE_READ: "vendor.tax_types.read",
  VENDOR_BILLING_ITEM_READ: "vendor.billing_items.read",
  VENDOR_LABEL_READ: "vendor.labels.read",
  VENDOR_INVOICE_READ: "vendor.invoices.read",
  VENDOR_HISTORICAL_INVOICES_READ: "vendor.historical_invoices.read",
  VENDOR_FUEL_TRANSACTION_READ: "vendor.fuel_transactions.read",
  VENDOR_EXPENDITURE_READ: "vendor.expenditures.read",
  VENDOR_TRIP_READ: "vendor.trips.read",
  VENDOR_PASSENGER_READ: "vendor.passengers.read",
  VENDOR_PERMISSION_GROUPS_READ: "vendor.permission_groups.read",
  VENDOR_PERMISSIONS_READ: "vendor.permissions.read",
  VENDOR_ROLE_READ: "vendor.roles.read",
  VENDOR_USER_READ: "vendor.users.read",
  VENDOR_PAYROLL_READ: "vendor.payroll.read",
  VENDOR_ATTENDANCE_DRIVER_READ: "vendor.attendance_driver.read",
  VENDOR_DRIVER_ATTENDANCE_BY_TRIPS_READ: "vendor.driver_attendance_by_trips.read",
  VENDOR_PAID_SLIPS_READ: "vendor.paid_slips.read",
  VENDOR_FILE_READ: "vendor.files.read",
  VENDOR_PETTY_CASH_READ: "vendor.petty_cash.read",
  VENDOR_TRIP_LABEL_READ: "vendor.trip_labels.read",
  VENDOR_GARAGE_READ: "vendor.garage.read",


  VENDOR_CAR_UPDATE: "vendor.cars.update",
  VENDOR_DRIVER_UPDATE: "vendor.drivers.update",
  VENDOR_VENDOR_UPDATE: "vendor.vendors.update",
  VENDOR_COMPANY_UPDATE: "vendor.companies.update",
  VENDOR_CONTRACT_UPDATE: "vendor.contracts.update",
  VENDOR_TRIP_TYPE_UPDATE: "vendor.trip_types.update",
  VENDOR_TAX_TYPE_UPDATE: "vendor.tax_types.update",
  VENDOR_BILLING_ITEM_UPDATE: "vendor.billing_items.update",
  VENDOR_LABEL_UPDATE: "vendor.labels.update",
  VENDOR_FUEL_TRANSACTION_UPDATE: "vendor.fuel_transactions.update",
  VENDOR_EXPENDITURE_UPDATE: "vendor.expenditures.update",
  VENDOR_TRIP_UPDATE: "vendor.trips.update",
  VENDOR_TRIP_BASIC_INFO_UPDATE: "vendor.trip_basic_info.update",
  VENDOR_TRIP_END_INFO_UPDATE: "vendor.trip_end_info.update",
  VENDOR_TRIP_BOOK_UPDATE: "vendor.trip_book.update",
  VENDOR_TRIP_ALLOT_DRIVER_UPDATE: "vendor.trip_allot_driver.update",
  VENDOR_TRIP_DISPATCH_UPDATE: "vendor.trip_dispatch.update",
  VENDOR_TRIP_COMPLETE_UPDATE: "vendor.trip_complete.update",
  VENDOR_TRIP_CANCEL_UPDATE: "vendor.trip_cancel.update",
  VENDOR_TRIP_CHARGES_UPDATE: "vendor.trip_charges.update",
  VENDOR_TRIP_LABEL_UPDATE: "vendor.trip_labels.update",
  VENDOR_TRIP_BILLING_ITEM_UPDATE: "vendor.trip_billing_items.update",
  VENDOR_TRIP_COMPLETED_UPDATE: "vendor.trips_completed.update",
  VENDOR_CONTRACT_FRONTEND_FORM_UPDATE: "vendor.contract_frontend_form.update",
  VENDOR_FUEL_TRANSACTION_APPROVED_UPDATE: "vendor.fuel_transaction_approved.update",
	VENDOR_FUEL_TRANSACTION_REJECTED_UPDATE: "vendor.fuel_transaction_rejected.update",
	VENDOR_EXPENDITURE_APPROVED_UPDATE: "vendor.expenditure_approved.update",
	VENDOR_EXPENDITURE_REJECTED_UPDATE: "vendor.expenditure_rejected.update",
  VENDOR_PETTY_CASH_UPDATE: "vendor.petty_cash.update",
  VENDOR_PAYROLL_PAID_UPDATE: "vendor.payroll_paid.update",
  VENDOR_ATTENDANCE_UPDATE: "vendor.attendance.update",
  VENDOR_PASSENGER_UPDATE: "vendor.passengers.update",
  VENDOR_ROLE_UPDATE: "vendor.roles.update",
  VENDOR_USER_UPDATE: "vendor.users.update",
  VENDOR_GARAGE_UPDATE: "vendor.garage.update",
  VENDOR_FUEL_STATION_CREATE: "vendor.fuel_stations.create",
	VENDOR_FUEL_STATION_READ: "vendor.fuel_stations.read",
  VENDOR_FUEL_STATION_UPDATE: "vendor.fuel_stations.update",
  VENDOR_FUEL_ANALYSIS_READ: "vendor.fuelanalysis.read",


  VENDOR_GARAGE_DELETE: "vendor.garage.delete",
    
};

export default PERMISSIONS;
